import { getGroupResultByKey } from "../../apis/httpHelper"
import { JSONReplacer, qweIsEmpty } from "../../common/commonHelper";
import { DefaultValueType } from "../../common/constant"

let qweBaseField = {
    props: {
        data: Object,
        definition: Object,
        contentType: String,
        formDefinition: Object,
        orginalDisplay: Object,
        htmlPrefix: String
    },

    inject:[
        "buildFormContext",
        "forceDisplay",
        "fullScreen",
        "validateForm"
    ],

    data: function () {
        return {
            formName: "",
            rules: [],
            name: "",
            displayName: "",
            hint: "",
            fieldName: "",

            selfSetting: {},
            fieldValueSetting: {},
            fieldCommonSetting: {},
            width:"",
            className:"",
        };
    },
    filterFunction: {},
    scriptFunction: {},
    created: function () {
        this.name = this.definition.Name;

        this.fieldValueSetting = this.definition.Settings.FieldValueSetting;
        this.fieldCommonSetting = this.definition.Settings.FieldCommonSetting;
        this.className = (this.fieldCommonSetting.ClassNames || []).join(" ")
        this.selfSetting = this.definition.Settings[this.definition.FieldDefinition.Name + "Setting"];


        let relyField = this.fieldValueSetting.hasOwnProperty("RelyFields") ? this.fieldValueSetting.RelyFields : [];
        this.width = this.fieldCommonSetting.Width;
        this.displayName = this.definition.Settings.ContentPartFieldSettings.DisplayName;
        if(!this.fieldCommonSetting.LabelShow){
            this.displayName = "";
        }
        this.hint = this.fieldCommonSetting.Hint;
        this.fieldName = (qweIsEmpty(this.htmlPrefix) ? "" : this.htmlPrefix + ".") + this.contentType + "." + this.name + ".Value";

        this.setBodyWithValueType();

        this.baseSetRules();
        this.subSetRules();

        this.initLogic();

        if(this.data[this.name] == null || this.data[this.name] == undefined){
            this.changeValue();
        }

        if(this.data[this.name] == null || this.data[this.name] == undefined){
            this.initValue();
        }

        let that = this;

        if (relyField.length > 0) {
            let self = this;
            (relyField || []).forEach(x => {
                this.$watch("data." + x, function (newVal, oldVal) {
                    self.changeValue();
                },{
                    deep:true
                })
            });
        }
    },
    computed: {
        disabled: function () {
            return !this.formDefinition[this.name]?.IsEdit || this.forceDisplay;
        },
        show: function () {
            return this.formDefinition[this.name]?.IsDisplay && this.orginalDisplay[this.name];
        }
    },
    
    methods: {
        checkInForm:function(cb){
            this.validateForm(cb);
        },

        initValue:function(){
            
        },

        subSetRules: function () {

        },

        baseSetRules: function () {
            if (this.formDefinition[this.name].IsRequired) {
                this.rules.push(this.buildRequiredRule());
            }
        },

        setDisplayState: function (state) {
            this.formDefinition[this.name].IsDisplay = state;
        },

        setEditState: function (state) {
            this.formDefinition[this.name].IsEdit = state;
        },

        setRequiredState: function (state) {
            if(state){
                let requiredIndex = this.rules.findIndex(x => x.hasOwnProperty("required"));
                if (requiredIndex == -1) {
                    this.rules.push(this.buildRequiredRule());
                }
            }
            else {
                let requiredIndex = this.rules.findIndex(x => x.hasOwnProperty("required"));
                if (requiredIndex > -1) {
                    this.rules.splice(requiredIndex,1);
                }
            }
        },

        setData:function(value){
            let result = this.setValueBeforeHook(value);
            this.data[this.name] = result;
        },

        buildRequiredRule:function(){
            return { required: true, message: '当前字段不能为空', trigger: 'blur' };
        },

        initLogic: function () {
            let functionExe = new Function("Context", "Content", "self", (this.fieldCommonSetting.LogicTemplate || ""));
            let self = this;
            if (this.fieldCommonSetting.hasOwnProperty("Fields") && this.fieldCommonSetting.Fields.length > 0) {
                (this.fieldCommonSetting.Fields || []).forEach(x => {
                    this.$watch("data." + x, function () {
                        let context = self.buildFormContext();
                        functionExe(context, self.data, self);
                    })
                });
            }
            let context = self.buildFormContext();
            functionExe(context, self.data, self);
        },

        changeValue: function () {
            switch (this.fieldValueSetting.DefaultValueType) {
                case DefaultValueType.Custom:
                    this.customFun();
                    break;
                case DefaultValueType.DataLinkage:
                    this.relyValueFun();
                    break;
                case DefaultValueType.Formula:
                    this.formulaExpression();
                    break;
                default:
                    break;
            }
        },

        customFun: function () {
            let result = this.setValueBeforeHook(this.selfSetting.CustomValue);
            this.data[this.name] = result;
        },

        relyValueFun: function () {
            let that = this;
            let SingleOperatorFilter = this.computedRequestData();

            if (SingleOperatorFilter.filters.length > 0) {
                getGroupResultByKey(this.fieldValueSetting.QueryContentType,
                    JSON.stringify(SingleOperatorFilter, JSONReplacer),
                    this.fieldValueSetting.QueryValue
                ).then(x=>{
                    that.relyValueFunSuccess(x.Result);
                }).catch(x=>{
                    console.log(this.displayName + "-" +this.name + "配置异常");
                    console.log(x);
                });
            }
        },

        formulaExpression: function () {
            let context = this.buildFormContext();

            try{
                let fuc = this.scriptFunction(context, this.data, this);

                if(fuc == undefined){
                    return;
                }
                else{
                    let result = this.setValueBeforeHook(fuc);
                    this.data[this.name] = result;
                }
            }
            catch(e){
                console.error(this.displayName +"："+ this.name + "字段公式编辑执行故障！",e)
            }
        },

        setValueBeforeHook: function (value) {
            return value;
        },

        computedRequestData: function () {
            let context = this.buildFormContext();
            let result = { "filters":[] };
            switch (this.fieldValueSetting.DefaultValueType) {
                case 0:
                case 2:
                    break;
                case 1:
                    result = this.filterFunction(context, this.data, this);
                    break;
                default:
                    break;
            }
            return result;
        },

        setBodyWithValueType: function () {
            try{
                if (this.fieldValueSetting.DefaultValueType == 1) {
                    this.filterFunction = new Function("Context", "Content",  "self", this.fieldValueSetting.RelySettingString);
                }
                if (this.fieldValueSetting.DefaultValueType == 2) {
                    this.scriptFunction = new Function("Context", "Content", "self", this.fieldValueSetting.Script);
                }
            }   
            catch(e){
                console.error(this.displayName +"："+ this.name + "字段公式编辑配置语法故障！",e)
            }
        },

        relyValueFunSuccess:function(result){
            if(result.length > 0){
                let data = result[0];
                if(data == undefined || data == null){
                    this.customFun();
                }
                else{
                    data = this.setValueBeforeHook(data);
                    this.data[this.name] = data;
                }
            }
            else{
                this.customFun();
            }
        }
    }
};

export default qweBaseField